import { useEffect, useRef } from 'react';
import type React from 'react';

import { cn } from '@change/ds-utils';

import { useIsVideoFirstArm } from '#src/app/pages/actions/shared/hooks';

import { RecordingDot } from '../RecordingDot';

export const VideoElementWrapper: React.FC<{
	stream: MediaProvider | null;
	isRecording: boolean;
}> = ({ stream, isRecording }) => {
	const videoRef = useRef<HTMLVideoElement>(null);
	/*
	 * The recorder was the one screen still sizing itself from the camera's native ratio, so the video
	 * changed shape between recording, preview and confirmation. Pinned to the same 3:4 portrait as the
	 * other two on the video-first arms, so it holds one shape across the flow (CHANGE-97687 review,
	 * 2026-08-25). Control keeps the native ratio it has today.
	 */
	const isVideoFirstArm = useIsVideoFirstArm();

	useEffect(() => {
		if (videoRef.current && stream) {
			videoRef.current.srcObject = stream;
		}
	}, [stream]);

	return (
		<div className={cn('relative w-full overflow-hidden rounded-lg bg-black', { 'aspect-[3/4]': isVideoFirstArm })}>
			<video
				className={cn('block w-full object-cover', { 'h-full': isVideoFirstArm })}
				autoPlay
				muted
				playsInline
				ref={videoRef}
				data-testid="recorder-video-element"
			/>
			<div className="absolute top-[2%] left-[2%] block">
				<RecordingDot isRecording={isRecording} />
			</div>
		</div>
	);
};
